export const VARIABLE_CONSTANT = {
  MAX_SIZE_25_MB: 25000000, 
  MAX_SIZE_25_MB_TEXT: "25Mb",
  MAX_SIZE_UPLOAD: 15728640,
  MAX_SIZE_TEXT: "15Mb",
  MAX_CARACTER: 30000,
  MAX_FILE_UPLOAD_PDF: 5242880,
  MAX_SIZE_PDF: "5Mb",
  DEFAULT_LATITUDE: -7.2458404,
  DEFAULT_LANGITUDE: 112.735629
}
